// WGK - Wassergefaehrdungsklasse (AwSV). The stored value is the label itself,
// the same way storage classifications are stored.
export const WATER_HAZARD_CLASSES = [
  "1",
  "2",
  "3",
  "Allgemein wassergefährdend",
];

export const WATER_HAZARD_CLASS_ITEMS = WATER_HAZARD_CLASSES.map((value) => ({
  name: value,
  value: value,
}));
